import { render } from "./RecepcionesIndex.vue?vue&type=template&id=f20f8b20"
import script from "./RecepcionesIndex.vue?vue&type=script&lang=js"
export * from "./RecepcionesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/recepciones/RecepcionesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f20f8b20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f20f8b20', __exports__)) {
    api.reload('f20f8b20', __exports__)
  }
  
  module.hot.accept("./RecepcionesIndex.vue?vue&type=template&id=f20f8b20", () => {
    api.rerender('f20f8b20', render)
  })

}


export default __exports__